import {Component, Input, OnInit, ViewChild} from '@angular/core';
import { AbstractFieldComponent } from '../../abstract/abstract-field.component';
import {CheckboxConfig} from '../../../models/field-config';
import {ResourceService} from '../../../services/resource.service';
import {FormFieldService} from '../../../services/form-field.service';
import {MatCheckbox} from '@angular/material';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss']
})
export class CheckboxComponent extends AbstractFieldComponent implements OnInit {

  @Input() index: string;
  expandText = false;
  @ViewChild('checkbox') checkbox: MatCheckbox;

  get checkboxConfig(): CheckboxConfig {
    return this.fieldConfig.checkboxConfig;
  }

  get hasCaptionCount(): boolean {
    return isNotNullOrUndefined(this.fieldConfig.captionCount);
  }

  get expandInline(): boolean {
    if (this.checkboxConfig.expand) {
      return isNotNullOrUndefined(this.checkboxConfig.expand.inline) ? this.checkboxConfig.expand.inline : false;
    }
    return false;
  }

  ngOnInit(): void {
    if (this.checkboxConfig.mappingConfig && this.fieldConfig.beanConfig) {
      this.initValue();
    }
    this.handleStatusChanges();
  }

  constructor(public formFieldService: FormFieldService,
              private resourceService: ResourceService) {
    super(formFieldService);
  }

  get readonlyConfig(): boolean {
    if (this.checkboxConfig && this.checkboxConfig.readonly) {
      if (this.checkboxConfig.readonly) {
        this.control.disable();
      }
      return this.checkboxConfig.readonly;
    } else {
      return false;
    }
  }

  get showIconChecked(): boolean {
    return !!this.checkboxConfig.iconChecked && this.checkbox.checked;
  }

  get captionAsHTML(): string {
    if (this.expandInline && this.expandText) {
      return this.checkboxConfig.expand.expandText;
    }
    return this.fieldConfig.captionAsHTML;
  }

  get ellipsisVisible(): boolean {
    return this.expandInline && !this.expandText;
  }

  get expandTextVisible(): boolean {
    return this.checkboxConfig.expand && this.checkboxConfig.expand.expandText !== '';
  }

  public toggleText(): void {
    if (this.expandText) {
      this.expandText = false;
    } else {
      this.expandText = true;
      setTimeout(() => this.resourceService.updatePdfLinks(), 0);
    }
  }

  toggleValue(): void {
    if (this.checkboxConfig.clickableLabel && !this.checkboxConfig.disableVisualChangesOnDisabled) {
      const value = !this.control.value;
      this.control.setValue(value);
    }
  }

  async onClick(event: PointerEvent) {
    if (this.isClickOnCheckboxContainer(event) || this.checkboxConfig.clickableLabel) {
      setTimeout(() => super.onClick(event), 0);
    }
  }

  private isClickOnCheckboxContainer(event: PointerEvent): boolean {
    return event && event.target ? event.target['classList'].contains('mat-checkbox-inner-container') : false;
  }

  private initValue(): void {
    const config = this.checkboxConfig.mappingConfig;
    const beanProperty = this.fieldConfig.beanConfig.propertyName ? this.fieldConfig.beanConfig.propertyName : null;
    const object = beanProperty ? this.bean[beanProperty][this.index] : this.bean[this.index];
    if (isNotNullOrUndefined(object)) {
      const valuesMapping = config.valuesMapping.find(valueMapping => valueMapping.propertyValue === object[config.propertyName]);
      if (isNotNullOrUndefined(valuesMapping)) {
        this.control.setValue(valuesMapping.checkboxValue);
      }
    }
  }
}
